<template>
  <div class="home-carousel">
    <el-carousel :interval="4000" trigger="click" class="carousel-container">
      <el-carousel-item v-for="item in carouselList" :key="item.id || item.imgUrl">
        <img
          class="carousel-image"
          :src="item.imgUrl"
          :alt="item.content || '轮播图'"
          @click="handleJump(item.url)"
        />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: 'HomeCarousel',
  props: {
    carouselList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleJump(url) {
      if (!url) {
        return
      }
      if (url.includes('/h5/#/')) {
        const path = url.split('/h5/#/')[1] || ''
        this.$router.push(path.startsWith('/') ? path : `/${path}`)
      } else {
        window.location.href = url
      } 
    },
  },
}
</script>

<style scoped lang="scss">
.home-carousel {
  width: 100%;
}

.carousel-container {
  height: 42vw;
}

:deep(.carousel-container .el-carousel__container) {
  height: 42vw !important;
}

.carousel-image {
  width: 100%;
  height: 100%;
  border-radius: 3.84615vw;
  object-fit: cover;
}

::v-deep(.el-carousel__container) {
  border-radius: 3.84615vw;
}

::v-deep(.el-carousel__indicators) {
  bottom: 1.8vw;
}

::v-deep(.el-carousel__indicator--horizontal) {
  padding: 0 0.9vw;
}

::v-deep(.el-carousel__button) {
  width: 1.8vw;
  height: 1.8vw;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.55);
}

::v-deep(.el-carousel__indicator.is-active .el-carousel__button) {
  background-color: #ffffff;
}
</style>
